'use client';
import { Box } from '@mui/material';

import { TradeButtons } from '@/components';
import type { CardVariantProps } from './types';

export function SimpleBinaryCard({ market, outcomes, onTradeClick }: CardVariantProps) {
  function handleYesClick(e: React.MouseEvent<HTMLButtonElement>) {
    e.preventDefault();
    e.stopPropagation();

    let outcomeId = `${market.id}-0`;
    if (Array.isArray(market.outcomes) && market.outcomes[0]) {
      outcomeId = market.outcomes[0].id;
    }

    onTradeClick?.(market.id, outcomeId, true);
  }

  function handleNoClick(e: React.MouseEvent<HTMLButtonElement>) {
    e.preventDefault();
    e.stopPropagation();

    let outcomeId = `${market.id}-1`;
    if (Array.isArray(market.outcomes) && market.outcomes[1]) {
      outcomeId = market.outcomes[1].id;
    }

    onTradeClick?.(market.id, outcomeId, true);
  }

  const yesOutcomeName = outcomes[0] || 'Yes';
  const noOutcomeName = outcomes[1] || 'No';

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
        mt: 'auto',
        gap: 2,
      }}
    >
      <TradeButtons
        onYesClick={handleYesClick}
        onNoClick={handleNoClick}
        yesLabel={yesOutcomeName}
        noLabel={noOutcomeName}
      />
    </Box>
  );
}
